import { h } from "preact";
import '../UploadDocument/upload-document-styles.scss'
import { deleteDocument, fetchStatus } from '../../../_rx/fct/actions'
import { useDispatch } from 'react-redux'
import { t } from '../../../_i18n'

export default function WeeklyFile ({ id, name, url, contractId, disabled= false }) {
  const dispatch = useDispatch()

  const handleRemove = () => {
      if (!disabled) {
          deleteDocument(id).then(() => dispatch(fetchStatus(contractId)))
      }
  }

  return (
    <div className='fct-upload-document__value m-bottom-half'>
      <div className='font-bold t-underline'><a className='cursor-pointer' href={url+'?download=true'} target="_blank" >{name}</a></div>
      <div className='font-bold t-underline cursor-pointer font-color-149BAB' onClick={handleRemove}>{ !disabled ? t('Eliminar') : ''}</div>
    </div>
  )
}
